import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Client } from "./API/client";
import { toastrService } from "./ux/toastr.service";

export interface Loan {
  loanNumber: number;
  contractNumber: string;
  principalAmount: number;
  leftPrincipalAmount: number;
  totalAmount: number;
  leftTotalAmount: number;
  installmentTotal: number;
  leftInstallment: number;
  currencyId: number;
  createdAt: any;
  finishAt: any;
  interestPlan: string;
  actualInterest: number;
  schedule: string;
}

@Injectable()
export class LoanService {
  private loanSource = new BehaviorSubject<Loan[]>([]);
  loans = this.loanSource.asObservable();

  constructor(private api: Client, private toastr: toastrService) {}

  public async getLoans() {
    try {
      const data = await this.api.get("api/loan/loans")
      this.loanSource.next(data as Loan[])
    } catch(err) {
      this.toastr.error(err.error)
    }
  }
}
